import React from 'react';

import { Grid, Container, Box, Typography } from '@material-ui/core/';

import CardWrapper from '../components/common/CardWrapper';

const PageConditions = () => (
	<Container maxWidth="lg">
		<Box mt={6}>
			<Grid item sm>
				<CardWrapper style={{ padding: '12px', margin: '6px' }}>
					<Typography variant="h4">Nutzerbedingungen (AGB`s)</Typography>
					<Typography variant="body1">Hier kommt der AGB Text rein.</Typography>
				</CardWrapper>
			</Grid>
		</Box>
	</Container>
);

export default PageConditions;
